module.exports = __webpack_public_path__ + "7a2a701c4b113944c565cc93e82494dd.png";